import React, { useState, useEffect } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap'
import DeleteModal from "components/Common/DeleteModal"
import { SuccessOk } from 'configs/statusCode'
import { toast } from 'react-toastify'
import { useSelector } from "react-redux"

const CardItem = (props) => {
    const { index, item, Service, status, setShouldGetData } = props
    const [itemStatus, setItemStatus] = useState(false)

    useEffect(() => {
        setItemStatus(status)
    }, [status])

    return (
        <tr key={index} className="payment-bgBadge">
            <td className='font-size-14'>{item.id}</td>
            <th className='font-size-14  ' style={{ textDecoration: "underline", fontWeight: 700 }}>{item.name.en}</th>
            <th className='font-size-14'> {item.compounds ?.map((comp, index) => {
                return (
                    <Badge
                        key={index}
                        className="bgBadge font-size-14 mt-0 m-1"
                        style={{ background: "#50a5f1", marginTop: "0px !important" }}
                    >
                        {comp.name.en}
                    </Badge>
                )
            })}</th>
            <td className='font-size-14 py-0'>
                <form>
                    <div className='form-check form-switch form-switch-md mb-1'>
                        <input
                            name='status'
                            checked={itemStatus}
                            type='checkbox'
                            className='form-check-input'
                            id='has_status'
                            readOnly={true}
                        />
                    </div>
                </form>
            </td>
        </tr>


    )
}

export default CardItem